import { createTintedImage } from '../utils/createTintedImage';
import { cutOutFrame } from '../utils/cutOutFrame';
import { game } from 'js/main';

export function prepareTintedBurstFx() {
  const colors = {
    'red': '#b81414',
    'blue': '#034eb0',
    'green': '#21a108',
    'pink': '#9708a1',
    'turquoise': '#0dbfa1',
    'yellow': '#fff700',
  };

  const atlas = 'ssheet';
  Object.keys((game.cache.getFrameData(atlas) as any)._frameNames).forEach((frameName) => {
    const frameImg = cutOutFrame(atlas, frameName);
    Object.entries(colors).forEach(([colorName, color]) => {
      // @ts-ignore
      game.cache.addImage(frameName.replace('%TYPE%', colorName), undefined, createTintedImage(frameImg, color));
    });
  });
}
